import React, { useCallback } from 'react';

import { Button, Tooltip } from 'antd';

import type { ShoppingDelivery } from 'v2/interfaces/shopping';
import shoppingProductService from 'v2/services/shopping/product';

import CcbAlert from './ccbAlert';

interface GetCcbTermProps {
  delivery: ShoppingDelivery;
}

const GetCcbTerm = ({ delivery }: GetCcbTermProps) => {
  const shouldShowButton = delivery.ccb;
  const handleClickDownload = useCallback(async (invoiceId: string) => {
    return shoppingProductService.getCcbTerm(invoiceId).subscribe({
      next: data => {
        const file = new File([data], `${invoiceId}.pdf`, {
          type: data.type
        });

        const url = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name;

        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      },
      error: err => {
        console.error('Erro ao realizar download, tente novamente', err);
      }
    });
  }, []);

  if (!shouldShowButton) {
    return <></>;
  }

  return (
    <>
      <CcbAlert />
      <Tooltip placement='top' title={!delivery.ccb ? 'Arquivo não disponível' : ''}>
        <div>
          <Button disabled={!delivery.ccb} onClick={() => handleClickDownload(delivery.invoice_id.toString())} block>
            Cédula de Crédito Bancário
          </Button>
        </div>
      </Tooltip>
    </>
  );
};

export default GetCcbTerm;
